export const BOXED_TYPE = Symbol.for("__boxed_type__");
